// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomThreadFollow
 */
export interface ClassroomThreadFollow {
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadFollow
     */
    classroom: string;
}

export function ClassroomThreadFollowFromJSON(json: any): ClassroomThreadFollow {
    return {
        'classroom': json['classroom'],
    };
}

export function ClassroomThreadFollowToJSON(value?: ClassroomThreadFollow): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'classroom': value.classroom,
    };
}


